import React from 'react'
import SbEditable from 'storyblok-react'
import { ContactBlock, type Card } from './ContactBlock'
import RichText from '@/utils/RichText'

export interface ContactInformationBlockProps {
  blok: StoryblokComponent & {
    heading: string
    text: string
    marginTop?: number
    marginBottom?: number
    cards: Card[]
  }
}

export const ContactInformationBlock = ({
  blok,
}: ContactInformationBlockProps) => {
  const marginStyles = {
    marginTop: blok.marginTop ? `${blok.marginTop}px` : undefined,
    marginBottom: blok.marginBottom ? `${blok.marginBottom}px` : undefined,
  }

  return (
    <div className="font-display max-w-4xl p-4 mx-auto" style={marginStyles}>
      {/** @ts-ignore: Storyblok typing issue with children **/}
      <SbEditable content={blok} key={blok._uid}>
        <h2 className="prose text-5xl font-semibold leading-tight mb-8">
          <RichText>{blok.heading}</RichText>
        </h2>
        {blok.text && (
          <p className="prose text-md text-darkblue mt-10 mb-12">
            <RichText>{blok.text}</RichText>
          </p>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 justify-center">
          {blok?.cards?.map((card: Card, idx: number) => (
            <ContactBlock blok={card} key={idx} />
          ))}
        </div>
      </SbEditable>
    </div>
  )
}

ContactInformationBlock.displayName = 'ContactInformationBlock'
